/** PII masking for session replay (default-on per the security rule). `maskAllInputs`
 *  redacts every input value; `maskAllText` redacts visible text nodes too. Password,
 *  email, and tel inputs are ALWAYS redacted regardless of options — turning masking
 *  off never exposes a credential field. */
export interface MaskOptions {
  maskAllInputs: boolean;
  maskAllText: boolean;
}

export const DEFAULT_MASK_OPTIONS: MaskOptions = {
  maskAllInputs: true,
  maskAllText: false,
};

const ALWAYS_MASKED_TYPES = new Set(['email', 'password', 'tel']);

/** Replaces every non-whitespace character with `*`, preserving length and word
 *  boundaries so the replay keeps layout without leaking content. */
export function redact(value: string): string {
  return value.replace(/\S/g, '*');
}

/** The value to record for an input, applying the always-masked types first and then
 *  the `maskAllInputs` option. */
export function maskInputValue(value: string, inputType: string | undefined, options: MaskOptions): string {
  if (isAlwaysMasked(inputType) || options.maskAllInputs) {
    return redact(value);
  }
  return value;
}

/** The text to record for a text node, applying the `maskAllText` option. */
export function maskText(text: string, options: MaskOptions): string {
  return options.maskAllText ? redact(text) : text;
}

function isAlwaysMasked(inputType: string | undefined): boolean {
  return ALWAYS_MASKED_TYPES.has((inputType ?? '').toLowerCase());
}
